const mutations = {

	SET_NAVIGATION(state, data) {
		console.debug('ORM|RESERVATION|M|SET_NAVIGATION', data);
		state.navigation = data;
	},
	UNSET_NAVIGATION(state) {
		console.debug('ORM|RESERVATION|M|UNSET_NAVIGATION');
		state.navigation = false;
	},


	SET_STATION(state, data) {
		console.debug('ORM|RESERVATION|M|SET_STATION', data);
		state.station = data;
	},
	UNSET_STATION(state) {
		console.debug('ORM|RESERVATION|M|UNSET_STATION');
		state.station = false;
	},


	SET_STARTDATE(state, date) {
		console.debug('ORM|RESERVATION|M|SET_STARTDATE', date);
		state.startdate = date;
	},
	UNSET_STARTDATE(state) {
		console.debug('ORM|RESERVATION|M|UNSET_STARTDATE');
		state.startdate = false;
	},


	SET_ENDDATE(state, date) {
		console.debug('ORM|RESERVATION|M|SET_ENDDATE', date);
		state.enddate = date;
	},
	UNSET_ENDDATE(state) {
		console.debug('ORM|RESERVATION|M|UNSET_ENDDATE');
		state.enddate = false;
	},

	SET_ESTIMATED_KM: function(state, data) {
		console.debug('ORM|RESERVATION|M|SET_ESTIMATED_KM', data);
		state.estimated_km = data;
	},
	UNSET_ESTIMATED_KM: function(state) {
		console.debug('ORM|RESERVATION|M|UNSET_ESTIMATED_KM');
		state.estimated_km = false;
	},
	
	SET_RENTALTYPE: function(state, data) {
		console.debug('ORM|RESERVATION|M|SET_RENTALTYPE', data);
		state.rentaltype = data;
	},
	UNSET_RENTALTYPE: function(state) {
		console.debug('ORM|RESERVATION|M|UNSET_RENTALTYPE');
		state.rentaltype = 0;
	},
	SET_RENTALCOMMENT: function(state, data) {
		console.debug('ORM|RESERVATION|M|SET_RENTALCOMMENT', data);
		state.rentalcomment = data;
	},
	SET_VOUCHER: function(state, data) {
		console.debug('ORM|RESERVATION|M|SET_VOUCHER', data);
		state.voucher = data;
	},
	UNSET_VOUCHER: function(state) {
		console.debug('ORM|RESERVATION|M|UNSET_VOUCHER');
		state.voucher = false;
	},

	SET_BILLKEY: function(state, data) {
		console.debug('ORM|RESERVATION|M|SET_BILLKEY', data);
		state.billKey = data;
	},

	SET_CAR: function(state, data) {
		console.debug('ORM|RESERVATION|M|SET_CAR', data);
		state.car = data;
	},
	UNSET_CAR: function(state) {
		console.debug('ORM|RESERVATION|M|UNSET_CAR');
		state.car = false;
	},

	SET_PRICES: function(state, data) {
		console.debug('ORM|RESERVATION|M|SET_PRICES', data);
		state.prices = data;
	},
	UNSET_PRICES: function(state) {
		console.debug('ORM|RESERVATION|M|UNSET_PRICES');
		state.prices = false;
	},

	SET_USER_SESSION: function(state, data) {
		console.debug('ORM|RESERVATION|M|SET_USER_SESSION', data);
		state.user_session = data;
	},
	UNSET_USER_SESSION: function(state) {
		console.debug('ORM|RESERVATION|M|UNSET_USER_SESSION');
		state.user_session = false;
	},
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/orm/reservation/mutations.js